<template>
  <WdsStack
    direction-column
    class="tw-mb-[30px] tw-flex-1 tw-border-spacing-1 tw-bg-true-gray-100 tw-p-6 tw-relative"
  >
    <div class="tw-text-2xl tw-font-display tw-mb-2">
      <slot name="title"></slot>
    </div>
    <slot></slot>
    <div class="shape tw-absolute tw-right-0 -tw-bottom-[5px]">
      <slot name="shape"></slot>
    </div>
  </WdsStack>
</template>

<script>
import { WdsStack } from '@worksome/wds-components'

export default {
  components: {
    WdsStack,
  },
}
</script>
